import React, { useState } from "react";
import Profile from "../../../../../Images/profile.jpg";
import ProfileCounter from "../ProfileCounters/ProfileCounter";
import { ROLES } from "../../../../../constants/roles";

export default function ProfileData({ allContracts, maintenanceSchedules, currentUser }) {
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(URL.createObjectURL(file));
    }
  };

  return (
    <div className="card ProfileData">
      <div className="card-header mb-2">
        <label htmlFor="imgProfile" className="logoCompany text-center d-flex align-items-center justify-content-center">
          <img src={selectedImage || currentUser?.profile_image || Profile} alt="Profile" style={{ width: "100px", height: "100px", borderRadius: "50%", objectFit: "cover" }} />
          <div className="mt-2">
            <input className="d-none" id="imgProfile" type="file" accept="image/*" onChange={handleImageChange} />
          </div>
        </label>
      </div>

      <div className="card-body mt-5">
        <ProfileCounter maintenanceSchedules={maintenanceSchedules} allContracts={allContracts} />
        <div className="text-center">
          <h4>{currentUser?.name}</h4>
          <p className="text-100">{currentUser?.role === ROLES.OWNER ? "مدير الشركة" : currentUser?.role === ROLES.MANAGER ? "مدير" : "موظف"}</p>
        </div>
      </div>
    </div>
  );
}
